import { ActionPanelContainer } from "./ActionPanelContainer";
import { H5, H6 } from "@sellar-io/components";
import React, { ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type ActionPanelType = "default" | "error";

export function ActionPanel({
  type = "default",
  title,
  message,
  className,
  children,
}: {
  type?: ActionPanelType;
  title: string;
  message?: string;
  className?: string;
  children?: ReactNode;
}): ReactElement {
  return (
    <ActionPanelContainer type={type} className={className}>
      <div className={"flex flex-col gap-1"}>
        <H5 className={twMerge(type === "error" && "text-red-800")}>{title}</H5>
        {message && <H6>{message}</H6>}
      </div>
      {children}
    </ActionPanelContainer>
  );
}
